/**
 * 登录、头像下来
 */
import * as React from 'react'
import classNames from 'classnames'
import { Dropdown, Tag } from 'antd'
import { IconSvg } from '@/components'
import config from '@/utils/config'
import { useTranslation } from '@/libs/next-lang'
import SwitchIdentities from '../SwitchIdentities'
import styles from './index.module.less'

export default function LoginBtn({
  name,
  menus,
  isPersonal,
  userInfo,
  onChange,
  onLogin,
  onLoginOut,
  campaignsNewGoBackChange,
}: any) {
  // 头像
  const avatar: string = userInfo?.avatar || config.defaultAvatar
  const { t } = useTranslation(['header'])
  // 下来菜单
  const menu = (
    <div>
      <div className={classNames('flex flex-row items-center', styles.info)}>
        <div
          className={classNames(styles['user-avatar'], styles['user-avatar-flex'])}
          style={{ width: 40, height: 40 }}
        >
          <img src={avatar} alt="avatar" />
        </div>
        <span title={name} className={styles.name}>
          {name}
        </span>
        <Tag color="#0055FE" style={{ borderRadius: 4, fontSize: 10, marginRight: 0 }}>
          {isPersonal ? t('header:t15') : t('header:t16')}
        </Tag>
      </div>
      <>
        <ul className={styles.menus}>
          {menus.map((item: any) => (
            <li
              key={item.label}
              className={classNames(
                'flex flex-row items-center cursor-pointer',
                styles.item,
                styles['menu-item'],
              )}
              onClick={() => onChange?.(item)}
            >
              <IconSvg className={styles.svg} type={item.icon} />
              <span className={styles.label}>{t(item.translateKey)}</span>
            </li>
          ))}
        </ul>
        <SwitchIdentities campaignsNewGoBackChange={campaignsNewGoBackChange} translateTxt={t} />
      </>
      <div className={styles.line} />
      <div
        className={classNames('flex flex-row items-center cursor-pointer', styles.loginOut)}
        onClick={onLoginOut}
      >
        <div className={classNames('flex flex-row items-center', styles.item)}>
          <IconSvg className={styles.svg} type="icon-tuichu1" />
          <span className={styles.label}>{t('header:t18')}</span>
        </div>
      </div>
    </div>
  )

  return (
    <div className={styles['login-btn']}>
      {userInfo.id ? (
        <Dropdown
          overlay={menu}
          placement="bottomRight"
          overlayClassName={classNames('cc-user-dropdown', styles.dropdown)}
          // trigger={['click']}
          align={{ offset: [4, 12] }}
          // open
        >
          <div className={classNames('flex flex-row items-center cursor-pointer', styles.avatar)}>
            <div className={styles['user-avatar']}>
              {avatar ? <img src={avatar} alt="avatar" /> : null}
            </div>
          </div>
        </Dropdown>
      ) : (
        <div
          id="d8e360"
          className={classNames('flex flex-row items-center cursor-pointer', styles.login)}
          onClick={onLogin}
        >
          <IconSvg type="icon-denglu" className={styles.loginSvg} />
          {t('header:t17')}
        </div>
      )}
    </div>
  )
}
